import { VoidFunctionComponent } from "react";
import cn from "classnames";
import styles from "./NavIcon.module.scss";
import { NavIconProps } from "./NavIcon.props";

export const NavIcon: VoidFunctionComponent<NavIconProps> = (props: NavIconProps): JSX.Element => {
  const { id, testId, className, icon: Icon } = props;
  const navIconClasses = cn("nav-icon", styles.navIcon, className);

  return (
    <div className={navIconClasses}>
      <Icon id={id} data-testid={testId ? `test__${testId}-nav-icon` : undefined} />
    </div>
  );
};
